<template>
  <div class="vr-player" :style="{ position: fullscreen ? 'fixed' : 'relative', zIndex: 999999 }">
    <div id="vr-player" @click="onToggleBar" class="vr-container"></div>
    <div v-if="loading" class="vr-loading" :style="{ position: fullscreen ? 'fixed' : 'absolute' }">
      <i class="icon-loading"></i>
    </div>

    <div v-if="!posterShow && !hiddenGuide" @click="onHiddenGuide" class="vr-guide">
      <div class="vr-guide-drag">
        <img src="./icon-drag.png" alt="" srcset="" />
        <div>360°拖动观看VR直播</div>
      </div>
      <div class="vr-guide-bottom">
        <img class="img-l" src="./icon-360.png" alt="" />
        <span>VR直播沉浸式观看体验，360°拖动试试吧</span>
        <img class="img-r" src="./icon-close.png" alt="" />
      </div>
    </div>
    <div
      @click="onClickBar"
      class="vr-control"
      :class="{ 'vr-controll-show': barShow || !hiddenGuide, 'vr-controll-hide': !barShow && hiddenGuide, 'vr-full-control': fullscreen }"
    >
      <div class="vr-btn-play" @click="onPlayOrPause">
        <van-icon v-if="paused" name="play" />
        <van-icon v-else name="pause" />
      </div>
      <div class="vr-time" v-if="timeShow">
        <span>{{ curTime }}</span>
        <span>/</span>
        <span>{{ totalTime }}</span>
      </div>
      <div class="vr-progress-bar" v-if="timeShow">
        <van-slider
          :value="percent"
          @input="onSliderInput"
          @change="onSliderChange"
          @drag-start="onDragStart"
          @drag-end="onDragEnd"
          active-color="#0094F7"
          :step="0.01"
          bar-height="3px"
        >
          <template #button>
            <div class="custom-button"></div>
          </template>
        </van-slider>
      </div>
      <div class="vr-gyro" @click="onToggleGyro">
        <span>
          <svg
            t="1703669770076"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2084"
            width="30"
            height="30"
          >
            <path
              d="M506.148571 516.754286m-384.365714 0a384.365714 384.365714 0 1 0 768.731429 0 384.365714 384.365714 0 1 0-768.731429 0Z"
              fill="#00000000"
              p-id="2085"
            ></path>
            <path
              fill="#00000000"
              d="M890.697143 597.942857c0 167.497143-172.068571 303.36-384 303.36s-384-135.862857-384-303.36z"
              p-id="2086"
            ></path>
            <path
              d="M506.148571 928.731429a411.977143 411.977143 0 1 1 411.977143-411.977143 412.16 412.16 0 0 1-411.977143 411.977143z m0-768a357.12 357.12 0 1 0 357.12 356.022857A357.485714 357.485714 0 0 0 506.148571 159.817143z"
              p-id="2087"
              :fill="gyro ? '#fff' : '#aaa'"
            ></path>
            <path
              d="M418.925714 697.782857A97.828571 97.828571 0 0 1 347.428571 671.085714c-52.48-52.662857-25.051429-162.56 62.537143-250.148571s197.485714-115.2 250.148572-62.537143c52.662857 52.662857 25.234286 162.56-62.354286 250.148571-57.417143 57.6-124.525714 89.234286-178.834286 89.234286z m170.24-310.857143c-36.571429 0-91.428571 24.502857-140.251428 73.142857-67.291429 67.291429-88.502857 146.285714-62.354286 172.617143s105.325714 4.754286 172.617143-62.537143 88.32-146.285714 62.354286-172.617142a44.982857 44.982857 0 0 0-32.365715-11.154286z"
              p-id="2088"
              :fill="gyro ? '#fff' : '#aaa'"
            ></path>
            <path
              d="M682.788571 722.468571a27.245714 27.245714 0 0 1-19.382857-8.045714l-167.314285-167.314286a27.428571 27.428571 0 1 1 38.765714-38.765714L702.171429 676.571429a27.611429 27.611429 0 0 1 0 38.765714 27.977143 27.977143 0 0 1-19.382858 7.131428zM416.731429 457.142857a26.88 26.88 0 0 1-19.382858-8.045714L310.857143 361.325714a27.245714 27.245714 0 0 1 0-38.765714 27.611429 27.611429 0 0 1 38.765714 0l87.04 87.04a27.245714 27.245714 0 0 1 0 38.765714 26.514286 26.514286 0 0 1-19.931428 8.777143z"
              p-id="2089"
              :fill="gyro ? '#fff' : '#aaa'"
            ></path>
          </svg>
        </span>
      </div>
      <div class="vr-fullscreen" @click="onToggleFullscreen">
        <span v-if="!fullscreen">
          <svg
            t="1703669941028"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3069"
            width="30"
            height="30"
          >
            <path
              d="M358.4 768H426.666667v85.333333H213.333333v-213.333333h85.333334v68.266667l128-128 59.733333 59.733333-128 128z m345.6 0l-128-128 59.733333-59.733333 132.266667 132.266666V640h85.333333v213.333333h-213.333333v-85.333333h64zM358.4 298.666667l128 128-59.733333 59.733333-128-128V426.666667H213.333333V213.333333h213.333334v85.333334H358.4z m345.6 0H640V213.333333h213.333333v213.333334h-85.333333V354.133333l-132.266667 132.266667-59.733333-59.733333 128-128z"
              fill="#fff"
              p-id="3070"
            ></path>
          </svg>
        </span>
        <span v-else>
          <svg
            t="1703669961714"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3223"
            width="30"
            height="30"
          >
            <path
              d="M298.666667 631.466667H226.133333v-81.066667h217.6v204.8h-85.333333v-68.266667l-128 128L170.666667 759.466667l128-128z m422.4 0l128 128-59.733334 59.733333-128-128v68.266667h-85.333333V554.666667h217.6v81.066666h-72.533333zM298.666667 341.333333L187.733333 230.4 243.2 170.666667l115.2 115.2V217.6h85.333333v204.8H226.133333V341.333333H298.666667z m430.933333 0h64v81.066667h-217.6V217.6h85.333333v72.533333L780.8 170.666667l59.733333 59.733333L729.6 341.333333z"
              fill="#fff"
              p-id="3224"
            ></path>
          </svg>
        </span>
      </div>
    </div>
    <div v-if="posterShow" class="vr-poster">
      <img class="poster" v-if="options" :src="options.poster" alt="" srcset="" />
      <span class="iconfont icon-play play-btn" @click="clickPlay"></span>
    </div>
  </div>
</template>

<script>
import * as Hls from 'mxreality.js/build/hls';
import * as THREE from 'mxreality.js/build/three';
import { VR, AVR } from 'mxreality.js/build/mxreality';

window.Hls = Hls;
window.THREE = THREE;
window.VR = VR;
window.AVR = AVR;

export default {
  name: 'VrPlayer',
  props: {
    options: Object
  },
  data() {
    return {
      vr: null,
      src: '',

      // 显示封面
      posterShow: true,
      // 加载涨停
      loading: true,
      // 播放状态
      paused: true,
      // 控制栏
      barShow: true,
      barTimer: null,
      // 陀螺仪
      gyro: true,
      // 全屏
      fullscreen: false,

      hiddenGuide: true,

      // 视频时间
      timeShow: false,
      totalTime: '00:00',
      curTime: '00:00',

      duration: 0,
      currentTime: 0,
      percent: 0,
      seeking: false,

      playerSettings: {}
    };
  },
  watch: {
    options: {
      handler(newVal) {
        console.log('options', newVal);
        if (newVal) {
          this.src = newVal.sources[0].src;
          const isHls = this.src.endsWith('.m3u8');
          this.timeShow = !isHls;
          if (this.vr) {
            this.vr.play(this.src, isHls ? this.vr.resType.sliceVideo : this.vr.resType.video);
          } else {
            this.$nextTick(() => {
              this.initVR(isHls);
            });
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    player() {
      return this.vr?.video;
    },
    toolbar() {
      return this.vr?.toolbar;
    }
  },
  mounted() {
    console.log('AVR.Broswer.webglAvailable()', AVR.Broswer, AVR.Broswer.webglAvailable());
    const _s = localStorage.getItem('vr-player-settings');
    const playerSettings = _s ? JSON.parse(_s) : {};
    if (!playerSettings.roomList) {
      playerSettings.roomList = [];
    }
    this.playerSettings = playerSettings;
  },
  destroyed() {
    if (this.vr) {
      this.vr.destroy();
    }
  },
  methods: {
    initVR(isHls = true) {
      const that = this;
      console.log('initVR isHls', isHls, this.src);
      if (
        navigator.userAgent.match(/iphone os 14_0/i) ||
        navigator.userAgent.match(/iphone os 14_1/i) ||
        navigator.userAgent.match(/iphone os 14_3/i)
      ) {
        AVR.__fixHlsRender = true;
      }
      var scene, renderer;
      var container;
      //renderer = new THREE.WebGLRenderer();
      AVR.debug = true;
      if (!AVR.Broswer.isIE() && AVR.Broswer.webglAvailable()) {
        renderer = new THREE.WebGLRenderer();
      } else {
        renderer = new THREE.CanvasRenderer();
      }
      renderer.setPixelRatio(window.devicePixelRatio);
      container = document.getElementById('vr-player');
      container.appendChild(renderer.domElement);
      scene = new THREE.Scene();

      const vr = new VR(scene, renderer, container);
      if (AVR.isCrossScreen()) {
        // 调整vr视窗偏移量
        vr.effect.separation = 1.2;
      }

      if (isHls) {
        // 设置hls.js 初始化参数
        vr.hlsConfig = {
          autoStartLoad: true
        };
      }
      // 播放初始配置
      vr.playCfg = {
        muted: false,
        autoplay: true
      };
      // 播放事件触发回调
      vr.videoPlayHook = function() {
        console.log('video play');
        // that.paused = false;
      };
      // 暂停事件触发回调
      vr.videoPauseHook = function() {
        console.log('video pause');
        // that.paused = true;
      };
      vr.loadProgressManager.onLoad = function() {
        // 视频静音
        // vr.video.muted=true;
        console.log('loaded.........');
      };
      vr.loadProgressManager.onProgress = function() {
        console.log('onProgress');
      };
      vr.loadProgressManager.onError = function() {
        console.log('onError');
      };
      // 设置播放器镜头自动旋转
      // vr.controls.autoRotate = true;
      // 设置自动旋转速度为1.2
      // vr.controls.autoRotateSpeed = 1.2;
      // 关闭陀螺仪
      // vr.controls.gyroFreeze();
      // 开启陀螺仪
      vr.controls.gyroUnfreeze();
      vr.vrbox.radius = 300;

      vr.init(function() {});
      vr.play(this.src, isHls ? vr.resType.sliceVideo : vr.resType.video);
      // sliceVideo
      vr.video.crossOrigin = 'Anonymous';
      // 视频已开始加载
      vr.video.onloadstart = function() {};
      // 当音频/视频的加载已放弃时触发。
      vr.video.onabort = function() {};
      // 当浏览器可以开始播放音频/视频时触发。
      vr.video.oncanplay = function() {
        that.loading = false;
        console.log('canplay');
        if (vr.video.paused) {
          that.playVideo();
        }
      };
      // 当浏览器可在不因缓冲而停顿的情况下进行播放时触发
      vr.video.oncanplaythrough = function() {
        console.log('oncanplaythrough');
        that.handleTips();
      };
      // 当音频/视频的时长已更改时触发。
      vr.video.ondurationchange = function() {};
      // 当目前的播放列表已结束时触发。
      vr.video.onended = function() {};
      // 当在音频/视频加载期间发生错误时触发。
      vr.video.onerror = function() {
        that.$emit('error');
      };
      // 当浏览器已加载音频/视频的当前帧时触发。
      vr.video.onloadeddata = function() {
        that.$emit('nloadeddata');
        console.log('nloadeddata');
      };
      // 当音频/视频已暂停时触发。
      vr.video.onpause = function() {
        console.log('onpause');
        that.$emit('pause');
      };
      // 当音频/视频已开始或不再暂停时触发。
      vr.video.onplay = function() {
        console.log('onplay');
        that.paused = false;
        that.posterShow = false;
        that.$emit('play');
      };
      // 当音频/视频在因缓冲而暂停或停止后已就绪时触发。
      vr.video.onplaying = function() {};
      // 当浏览器正在下载音频/视频时触发。
      vr.video.onprogress = function() {};
      // 当音频/视频的播放速度已更改时触发。
      vr.video.onratechange = function() {};
      // 当用户已移动/跳跃到音频/视频中的新位置时触发。
      vr.video.onseeked = function() {
        that.seeking = false;
        that.loading = false;
      };
      // 当用户开始移动/跳跃到音频/视频中的新位置时触发。
      vr.video.onseeking = function() {
        that.seeking = true;
        that.loading = true;
      };
      // 当浏览器尝试获取媒体数据，但数据不可用时触发。
      vr.video.onstalled = function() {};
      // 当浏览器刻意不获取媒体数据时触发。
      vr.video.onsuspend = function() {};
      // 当目前的播放位置已更改时触发。
      vr.video.ontimeupdate = function() {
        if (!that.timeShow) return;
        that.curTime = AVR.formatSeconds(vr.video.currentTime);
        that.totalTime = AVR.formatSeconds(vr.video.duration);
        that.duration = vr.video.duration;
        that.currentTime = vr.video.currentTime;
        // 计算百分比
        if (!that.seeking && vr.video.duration) {
          that.percent = Math.floor((vr.video.currentTime / vr.video.duration) * 100);
        }
      };
      // 当音量已更改时触发。
      vr.video.onvolumechange = function() {};
      // 当视频由于需要缓冲下一帧而停止时触发。
      vr.video.onwaiting = function() {
        console.log('onwaiting');
        that.loading = true;
      };
      this.vr = vr;
      this.initBar();
    },
    handleTips() {
      const _s = localStorage.getItem('vr-player-settings');
      const playerSettings = _s ? JSON.parse(_s) : {};
      if (!playerSettings.roomList) {
        playerSettings.roomList = [];
      }
      this.playerSettings = playerSettings;
      // 第一次进该VR直播间
      if (playerSettings.roomList.indexOf($$.module.data.room.roomId) === -1) {
        console.log('guide true');
        this.hiddenGuide = false;
      }
    },
    initBar() {
      console.log('vr.toolBar', this.vr.toolBar);
      this.$emit('ready', this.vr);
    },
    clickPlay(e) {
      this.playVideo(e);
      console.log('AVR.Broswer.webglAvailable()', AVR.Broswer, AVR.Broswer.webglAvailable());
    },
    // 隐藏工具栏
    handleHideBar() {
      clearTimeout(this.barTimer);
      this.barTimer = setTimeout(() => {
        this.barShow = false;
      }, 1000);
    },
    // 工具栏
    onToggleBar() {
      console.log('onToggleBar');
      clearTimeout(this.barTimer);
      this.barShow = !this.barShow;
      if (this.barShow) {
        this.barTimer = setTimeout(() => {
          this.barShow = false;
        }, 3000);
      }
    },
    // 播放暂停
    onPlayOrPause() {
      if (this.paused) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
      this.handleHideBar();
    },
    playVideo() {
      this.vr._play();
      this.vr.video.play();
    },
    pauseVideo() {
      this.vr._pause();
      this.vr.video.pause();
      // this.vr.videoPauseHook();
      this.paused = true;
    },
    // 陀螺仪
    onToggleGyro() {
      if (this.gyro) {
        this.vr.controls.gyroFreeze();
      } else {
        // 开启陀螺仪
        this.vr.controls.gyroUnfreeze();
      }
      this.gyro = !this.gyro;
      this.handleHideBar();
    },
    // 全屏
    onToggleFullscreen() {
      console.log('vr', this.vr, this.vr.controls);
      this.fullscreen = !this.fullscreen;
      this.$emit('fullscreen', this.fullscreen)
      this.handleHideBar();
    },
    // 引导
    onHiddenGuide() {
      this.hiddenGuide = true;
      // 触发一次引导之后，记录
      this.playerSettings.roomList.push($$.module.data.room.roomId);
      localStorage.setItem('vr-player-settings', JSON.stringify(this.playerSettings));
      console.log('guide false');
    },
    onClickBar() {
      console.log('click bar');
      this.onHiddenGuide();
    },
    // 进度条seek
    onDragStart() {
      if (this.duration) {
        this.seeking = true;
      }
    },
    onDragEnd() {},
    onSliderInput(value) {
      if (this.duration) {
        this.percent = value;
        this.handleHideBar();
      }
    },
    onSliderChange(value) {
      if (this.duration) {
        const currentTime = this.duration * (value / 100);
        this.vr.video.currentTime = currentTime;
      }
    }
  }
};
</script>

<style lang="less">
._toolBarArea,
.vr-voice {
  display: none !important;
}
</style>
<style lang="less" scoped>
@keyframes loadingrotate {
  to {
    transform: rotate(360deg);
  }
}

.vr-player {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .vr-container {
  }
  .vr-poster {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .poster {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
      border-radius: 50%;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      font-size: 50px;
      color: #fff;
    }
  }
  .vr-control {
    position: absolute;
    bottom: -40px;
    left: 0;
    &.vr-full-control {
      position: fixed;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }

    background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.4) 100%);
    display: flex;
    width: 100%;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    opacity: 0;
    &.vr-controll-show {
      opacity: 1;
      transition: all 0.2s;
      bottom: 0;
    }
    &.vr-controll-hide {
      opacity: 0;
      transition: all 0.2s;
      bottom: -40px;
      pointer-events: none;
    }
    .vr-btn-play {
      width: 40px;
      height: 40px;
      flex: 0 0 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        color: #fff;
        font-size: 30px;
      }
    }
    .vr-fullscreen {
      width: 40px;
      height: 40px;
      flex: 0 0 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        color: #fff;
        font-size: 24px;
      }
    }
    .vr-gyro {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 14px;
      margin-left: auto;
      position: relative;
      height: 40px;
      width: 40px;
      flex: 0 0 40px;
    }
  }
  .vr-time {
    color: #fff;
    line-height: 40px;
    font-size: 14px;
    height: 40px;
  }
  .vr-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 64px;
    height: 64px;
    border-radius: 4px;
    text-align: center;

    &:after {
      content: '正在加载';
      color: #fff;
      font-size: 14px;
    }
    .icon-loading {
      display: block;
      background: url(./loading.png) no-repeat;
      background-size: 100%;
      width: 30px;
      height: 30px;
      animation: loadingrotate 1s linear infinite;
      margin-bottom: 8px;
      margin-left: 17px;
    }
  }
  .vr-guide {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    .vr-guide-drag {
      text-align: center;
      color: #fff;
      font-size: 12px;
      margin-top: 32px;
      font-weight: 500;
    }
    .vr-guide-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100px;
      background: linear-gradient(180deg, rgba(0, 148, 247, 0) 0%, #0094f7 100%);
      display: flex;
      justify-content: space-between;
      color: #fff;
      padding-top: 23px;
      padding-left: 24px;
      padding-right: 24px;
      span {
        font-size: 12px;
        line-height: 24px;
        font-weight: 500;
      }
      .img-l {
        width: 24px;
        height: 24px;
      }
      .img-r {
        width: 24px;
        height: 24px;
      }
    }
  }
  .vr-progress-bar {
    flex: 1;
    padding: 0 12px;
    .custom-button {
      width: 12px;
      height: 12px;
      color: #fff;
      font-size: 10px;
      line-height: 18px;
      text-align: center;
      background-color: #fff;
      border-radius: 100px;
    }
  }
}
</style>
